var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var template = "\n  <div class=\"form-group\" :class=\"{ required: !!required }\">\n    <label :for=\"`textarea-group${_uid}`\"\n           class=\"control-label\">\n      {{ label }}\n      <slot></slot>\n    </label>\n\n    <textarea \n      :id=\"`textarea-group${_uid}`\"\n      :maxlength=\"maxlength\"\n      :required=\"!!required\"\n      :placeholder=\"placeholder\"\n      v-model=\"computedModel\"\n      :disabled=\"disabled\"\n      :rows=\"rows\"\n      class=\"form-control\"\n      @focus=\"focusEvent\"\n      @blur=\"blurEvent\"\n    ></textarea>\n  </div>\n";
import { Component, Prop, Vue } from 'vue-property-decorator';
var InputTextarea = /** @class */ (function (_super) {
    __extends(InputTextarea, _super);
    function InputTextarea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(InputTextarea.prototype, "computedModel", {
        get: function () {
            return this.value;
        },
        set: function (val) {
            this.updateValue(val);
        },
        enumerable: true,
        configurable: true
    });
    InputTextarea.prototype.updateValue = function (val) {
        this.$emit('input', val);
    };
    InputTextarea.prototype.focusEvent = function () {
        this.$emit('focus');
    };
    InputTextarea.prototype.blurEvent = function () {
        this.$emit('blur');
    };
    __decorate([
        Prop({ type: String, default: null }),
        __metadata("design:type", Object)
    ], InputTextarea.prototype, "value", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], InputTextarea.prototype, "label", void 0);
    __decorate([
        Prop({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], InputTextarea.prototype, "required", void 0);
    __decorate([
        Prop({ type: [String, Number] }),
        __metadata("design:type", Object)
    ], InputTextarea.prototype, "maxlength", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], InputTextarea.prototype, "placeholder", void 0);
    __decorate([
        Prop({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], InputTextarea.prototype, "disabled", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], InputTextarea.prototype, "rows", void 0);
    InputTextarea = __decorate([
        Component({ template: template })
    ], InputTextarea);
    return InputTextarea;
}(Vue));
export { InputTextarea };
//# sourceMappingURL=InputTextarea.js.map